import { AuthState } from '@/features/auth/types/auth-state';
import { _clientNow, _unixToClientTime } from '@/shared/functions/timezone';
import Joi from 'joi';

export default function legacy_parseAndValidateAccessToken(
  auth_data: string,
  checkExpiration = true
): AuthState['token'] | null {
  try {
    const mayBeValidAuthData = JSON.parse(auth_data);
    const schema = Joi.object({
      value: Joi.string().required(),
      expiresAt: Joi.number().required(),
      refreshToken: Joi.string().optional(),
      rememberMe: Joi.boolean().optional(),
      refreshTokenExpiresAt: Joi.number().optional(),
    });

    const { error, value } = schema.validate(mayBeValidAuthData, {
      allowUnknown: true,
    });
    if (error) return null;

    if (checkExpiration && _unixToClientTime(value.expiresAt).isBefore(_clientNow())) return null;
    return value as AuthState['token'];
  } catch (e) {
    return null;
  }
}
